// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader___h4Ab","loaderOuter":"PageOverlayLoader_loaderOuter__3_9q1"};